import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";

type UseCreateReferenceMeasurementMutationVariables = {
  tourId: string;
  positions: Position3D[];
  distance: number;
  metadata?: Record<string, unknown>;
};

export const useCreateReferenceMeasurement = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: async (
      payload: UseCreateReferenceMeasurementMutationVariables
    ) => {
      const data = await authApi.post(
        `/virtual-tour/reference-measurement`,
        payload
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["virtual-tour-reference-measurements"],
      });
    },
  });

  return result;
};
